module.exports = __webpack_public_path__ + "static/sportlivereisen-f0e56c06a4a14bfc92312d1afbf3c5f8.svg";